import React from "react"
import type { ParametrosIntegracaoModel } from "../models/parametrosIntegracaoModel"
import { ParametrosIntegracaoInicial } from "../models/parametrosIntegracaoModel"
import type { ParametrosIntegracaoActionModel } from "./parametrosIntegracaoActions"
import { parametrosIntegracaoReducer } from "./parametrosIntegracaoReducer"

type ParametrosIntegracaoContextType = {
    parametros: ParametrosIntegracaoModel
    dispatch: React.Dispatch<ParametrosIntegracaoActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const ParametrosIntegracaoContext = React.createContext<ParametrosIntegracaoContextType>({
    parametros: ParametrosIntegracaoInicial,
    dispatch: () =>
        parametrosIntegracaoReducer(ParametrosIntegracaoInicial, {
            type: "CARREGAR" as never,
            payload: ParametrosIntegracaoInicial,
        }),
    salvar: async () => {},
    erroCarregamento: null,
})
